<template>
    <div class="layout__position-left layout__width-100">

        <el-form :model="searchParams" status-icon :rules="rules" ref="searchParams">

            <div class="layout__padding-clear text__align-center layout__width-100">
                <div class="layout__search-field__insights-250px">
                    <p class="layout__margin__bottom-10 text__align-left">Month/Year</p>
                    <el-form-item prop="salesDateRange">
                        <el-date-picker
                            v-model="searchParams.billingDate"
                            type="month"
                            align="left"
                            start-placeholder="Start Month"
                            end-placeholder="End Month"
                            :picker-options="pickerOptions"
                            format="MM/yyyy"
                            value-format="MM/yyyy">
                        </el-date-picker>
                    </el-form-item>
                </div>
            </div>

        </el-form>

        <el-button class="button-red button__base button__insights" v-on:click="getSales('searchParams')">Refresh Data
        </el-button>

        <el-button class="button-teal button__base button__insights" :disabled="this.sales.length === 0" v-on:click="csv()">Download CSV
        </el-button>

    </div>

</template>

<script>

    import Axios from 'axios';
    import moment from 'moment';
    import download from 'downloadjs';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import chartHeatmapBase from '../../mixins/chart-heatmap-base.js';

    export default {
        name: "monthlyInvoicingListSearch",
        mixins: [axios, csvDownloadHelper, dataFormatter],
        props: {
            searchParams: {},
            sales: []
        },
        data() {
            return {
                serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
                downloadUrl: '',
                pickerOptions: {
                    shortcuts: [{
                        text: 'This month',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }]
                }            }
        },
        created() {
            console.log('CREATED');
            const date = new Date();
            date.setDate(date.getDate() - 7);
            console.log('created date');

            this.searchParams.billingDate = moment().format('MM/YYYY');
        },
        mounted() {
            console.log('MOUNTED');
            this.getSales('searchParams');
        },
        destroyed() {
            console.log('DESTROYED');
            this.searchParams.billingDate = moment().format('MM/YYYY');
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_search', JSON.stringify(this.searchParams));
        },
        methods: {
            getSales(searchParams) {
                console.log('before')
                console.log(this.searchParams)

                let searchTerms = Object.assign({}, this.searchParams)
                console.log('searchTerms')
                console.log(searchTerms)

                console.log('after search is copied')
                console.log(this.searchParams)

                console.log('after search is copied - new object')
                console.log(searchTerms)

                var billingDateArray = searchTerms.billingDate.split("/"),
                    billMonth = billingDateArray[0],
                    billYear = billingDateArray[1],
                    endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetMonthlyInvoicingList?Month=' + billMonth + '&Year=' + billYear;

                console.log(endpoint)

                this.$parent.loading = true;

                Axios.get(endpoint, this.returnHeaderUsingToken())
                .then(response => {
                    var orders = response.data.monthlyInvoicing;

                    this.$parent.sales = orders;

                    this.$nextTick(() => { // Loading should be closed asynchronously
                        this.$parent.loading = false;
                    });
                })
            },
            getFormattedDate(value) {
                let dateTimeArray = value.toString().split(/ (.+)/);
                let dateArray = dateTimeArray[0].toString().split("/");
                return dateArray[1] + '/' + dateArray[0] + '/' + dateArray[2] + ' ' + moment(dateTimeArray[1], 'hh:mm:ss A').format('HH:mm:ss');
            },
            removeNull(value) {
                if (value == null) {
                    return ""
                } else {
                    return value.trim()
                }
            },
            csv(index, row) {
                var monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];

                const fields = [
                    {label: 'Type', value: 'type'},
                    {label: 'Status', value: 'status'},
                    {label: 'Bill Month', value: (row, field) => monthNames[row.bill_month - 1]},
                    {label: 'Bill Year', value: 'bill_year'},
                    {label: 'Branch', value: 'branch'},
                    {label: 'Name', value: (row, field) => row.name.trim()},
                    {label: 'Head Office', value: 'head_office'},
                    {label: 'Net Total', value: 'net_total'},
                    {label: 'Territory', value: 'territory'},
                    {label: 'Brand', value: (row, field) => row.brand.trim()},
                    {label: 'First Order', value: (row, field) => this.getFormattedDate(row.first_order)},
                    {label: 'Last Order', value: (row, field) => this.getFormattedDate(row.last_order)},
                    {label: 'Address Line 1', value: (row, field) => row.address1.trim()},
                    {label: 'Address Line 2', value: (row, field) => row.address2.trim()},
                    {label: 'Town', value: (row, field) => row.town.trim()},
                    {label: 'County', value: (row, field) => row.county.trim()},
                    {label: 'Postcode', value: (row, field) => row.postcode.trim()},
                    {label: 'Software', value: (row, field) => this.removeNull(row.software)},
                    {label: 'Netsuite ID', value: 'netsuite_id'},
                    {label: 'Salesforce ID', value: 'salesforce_id'},
                ];

                this.downloadCsv(this.exportDate, fields, this.sales);
            }
        }
    };
</script>